import deliveryOrder from '@/router/stationMissionCenter/deliveryOrder.js'
export default [
  {
    path: '/stationOperation',
    name: 'stationOperation',
    component: () => import('@/pages/stationMissionCenter/operationHome/index.vue'),
    meta: {
      storeKey: 'station.operation.manage'
    }
  },
  {
    path: '/stationOperation/findCarQuickly', // 快速找车
    name: 'findCarQuickly',
    component: () => import('@/pages/stationMissionCenter/findCarQuickly/index.vue'),
    meta: {
      storeKey: 'station.operation.manage'
    }
  },
  {
    path: '/stationTaskCenter', // 场站运营 - 任务中心
    name: 'stationTaskCenter',
    component: () => import('@/pages/stationMissionCenter/taskCenter/index.vue'),
    meta: {
      storeKey: 'station.operation.manage'
    }
  },
  {
    path: '/createNewPaperlessDeliveryCar', // 场站运营 - 任务中心 - 租赁交车 - 交车工单详情
    name: 'createNewPaperlessDeliveryCar',
    component: () => import('@/pages/stationMissionCenter/taskCenter/views/deliveryCar/createPaperlessDeliveryCar.vue'),
    meta: {}
  },
  {
    path: '/createNewPaperlessReturnCar', // 场站运营 - 任务中心 - 退车 - 交车工单详情
    name: 'createNewPaperlessReturnCar',
    component: () => import('@/pages/stationMissionCenter/taskCenter/views/returnCar/createPaperlessReturnCar.vue'),
    meta: {
      storeKey: 'trs.returnCar.index'
    }
  },
  {
    path: '/createReturnOrder', // 场站运营 - 任务中心 - 售车交车 - 交车工单详情
    name: 'createReturnOrder',
    component: () => import('@/pages/stationMissionCenter/taskCenter/views/returnCar/components/createReturnOrder.vue'),
    meta: {}
  },
  {
    path: '/createSaleCar',
    name: 'createSaleCar',
    component: () => import('@/pages/stationMissionCenter/taskCenter/views/saleCar/createSaleCar.vue'),
    meta: {}
  },
  {
    path: '/modifyExpensesList',
    name: 'modifyExpensesList',
    component: () => import('@/pages/stationMissionCenter/taskCenter/views/returnCar/components/returnCarFee.vue'),
    meta: {}
  },
  {
    path: '/updateExplain',
    name: 'updateExplain',
    component: () => import('@/pages/stationMissionCenter/operateInstruction/updateExplain.vue')
  },
  {
    path: '/manualExplain',
    name: 'manualExplain',
    component: () => import('@/pages/stationMissionCenter/operateInstruction/manualExplain.vue')
  },
  {
    path: '/businessMenu',
    name: 'businessMenu',
    component: () => import('@/pages/stationMissionCenter/operateInstruction/businessMenu.vue')
  },
  {
    path: '/motivation',
    name: 'motivation',
    component: () => import('@/pages/stationMissionCenter/motivation/index.vue'),
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/mileageTask',
    name: 'mileageTask',
    component: () => import('@/pages/stationMissionCenter/mileageTask/index.vue'),
    meta: {
      storeKey: 'station.operation.manage:mileageTask'
    }
  },
  {
    path: '/createMileageTask',
    name: 'createMileageTask',
    component: () => import('@/pages/stationMissionCenter/mileageTask/views/createMileageTask/index.vue')
  },
  {
    path: '/messageCenter',
    name: 'messageCenter',
    component: () => import('@/pages/stationMissionCenter/messageCenter/index.vue')
  },
  {
    path: '/privacyManagement',
    name: 'privacyManagement',
    component: () => import('@/pages/stationMissionCenter/privacyManagement/index.vue')
  },
  {
    path: '/accountCancellation',
    name: 'accountCancellation',
    component: () => import('@/pages/stationMissionCenter/accountCancellation/index.vue')
  },
  {
    path: '/completedOrderNumber', // 完成工单数量页面
    name: 'completedOrderNumber',
    component: () => import('@/pages/stationMissionCenter/completedOrderNumber/index.vue'),
    meta: {
      // storeKey: 'station.operation.manage'
    }
  },
  {
    path: '/createForcedReturnCar', // 强收强退工单
    name: 'createForcedReturnCar',
    component: () => import('@/pages/stationMissionCenter/forcedReturnCar/index.vue')
  },
  {
    path: '/compliancePhoto', // 合规照片上传
    name: 'compliancePhoto',
    component: () => import('@/pages/stationMissionCenter/compliancePhoto/index.vue'),
    meta: {
      storeKey: 'station.operation.manage'
    }
  },
  {
    path: '/configMenu', // 常用功能设置
    name: 'configMenu',
    component: () => import('@/pages/stationMissionCenter/configMenu/index.vue')
    // meta: {
    //   storeKey: 'station.operation.manage'
    // }
  },
  {
    path: '/sbyConfigMenu', // 常用功能设置
    name: 'sbyConfigMenu',
    component: () => import('@/pages/stationMissionCenter/configMenu/sbyConfigMenu.vue')
    // meta: {
    //   storeKey: 'station.operation.manage'
    // }
  },
  {
    path: '/deliveryAgent', // 代交车
    name: 'DeliveryAgent',
    component: () => import('@/pages/stationMissionCenter/deliveryAgent/index.vue'),
    meta: {
      storeKey: 'trs.proxyDelivery.index'
    }
  },
  {
    path: '/deliveryAgentDetail', // 代交车工单详情
    name: 'DeliveryAgentDetail',
    component: () => import('@/pages/stationMissionCenter/deliveryAgent/deliveryAgentDetail/index.vue'),
    meta: {
      storeKey: '*'
    }
  },
  ...deliveryOrder
]




// WEBPACK FOOTER //
// ./src/router/stationMissionCenter/index.js